import React from 'react';
import PropTypes from 'prop-types';
import elementType from 'prop-types-extra/lib/elementType';
import TabContainer from '../TabContainer/TabContainer.js';
import TabContent from '../TabContent/TabContent.js';
import TabPane from '../TabPane/TabPane.js';
import { jsx as _jsx } from "react/jsx-runtime";
class Tab extends React.Component {
  render() {
    const props = {
      ...this.props
    };

    // These props are for the parent `<Tabs>` rather than the `<TabPane>`.
    delete props.title;
    delete props.disabled;
    delete props.tabClassName;
    return /*#__PURE__*/_jsx(TabPane, {
      ...props
    });
  }
}
Tab.Container = TabContainer;
Tab.Content = TabContent;
Tab.Pane = TabPane;
export default Tab;